import { render, staticRenderFns } from "./StudiesLayout.vue?vue&type=template&id=0a8923f0&"
import script from "./StudiesLayout.vue?vue&type=script&lang=js&"
export * from "./StudiesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports